import graphqlFetch from '@helpers/api/graphql-fetch';
import { gql } from 'graphql-request';

export const infoBoxData = gql`
  id
  linkType {
    ... on LinkRecord {
      id
      name
      url
    }
    ... on TaxonomyRecord {
      id
      url: taxonomyUrl
      name: taxonomyName
    }
  }
  link
  content
  context
  icon {
    iconSlug
  }
`;

export const infoBoxGql = gql`
  query InfoBoxQuery {
    infoBox: allInfoBoxes {
      ${infoBoxData}
    }
  }
`;

export type TInfoBox = {
  infoBox: {
    _modelApiKey?: string;
    link?: string;
    content?: string;
    name?: string;
    linkType?: Record<string, any>;
    context?: string;
    icon?: {
      iconSlug: string;
    };
  };
}[];

export async function getInfoBoxData({ preview }: { preview?: boolean }): Promise<TInfoBox> {
  return graphqlFetch(infoBoxGql, {
    preview,
  });
}
